import React, {useEffect, useState} from 'react';
import CurrencyInput from 'react-currency-input-field';
import {
    IonItem,
    IonLabel,
    IonButton,
    IonCheckbox
} from '@ionic/react';
import './Auctions.css';

import {IOrder} from "../components/Outbound/IOrder";
import NegotiatorWidget from "../components/NegotiatorWidget";
import {useBidRates} from "../components/hooks/useBidRates";
import {AuthUser} from "aws-amplify/auth";


interface AuctionProps {
    order: IOrder,
    onSave?: (item: IOrder) => void
    user: AuthUser
}

const Auctionedit: React.FC<AuctionProps> = ({order, onSave, user}) => {
    const [state, setState] = useState({buttonDisabled: false})
    const {bidRates} = useBidRates({orderId: order.orderID, user: user});
    useEffect(() => {
        setState({buttonDisabled: false})
    }, [order]);
    const addUpdateLoad = () => {
        setState({buttonDisabled: true})
        if (onSave)
            onSave(order ?? {} as IOrder)
    };
    const updateValue = (field: string, value: any) => {
        if (order)
            order.bookNowRate = value;
    };
    console.log("Bid Rates", bidRates)
    return (

        <div className="ion-padding  w-full">
            <IonItem>
                <div className={"flex flex-col text-center align-middle w-[75%] m-auto"}>
                    <NegotiatorWidget bidRates={{
                        maxBid: `${bidRates.MaxBidRED}`,
                        moneyMaker: `${bidRates.MoneyMakerBidGREEN}`,
                        breakEven: `${bidRates.BreakEvenBidYELLOW}`,
                        lastShip: `${bidRates.AvgLast3ShipTo}`,
                        suggestedBid: `${bidRates.SuggestedBid}`,
                        recBid: `${bidRates.SuggestedBid}`
                    }}/>
                </div>
            </IonItem>
            <IonItem>


                <IonLabel>Book Now Rate</IonLabel>
                $ &nbsp;<CurrencyInput placeholder="Please enter a number"
                                       className={"border p-1"}
                                       defaultValue={order?.bookNowRate}
                                       decimalsLimit={2}
                                       onValueChange={(value, name) => {
                                           updateValue('bookNowRate', value)
                                       }}/>
            </IonItem>
            <IonItem>
                <IonLabel>Hot Load</IonLabel>
                <IonCheckbox defaultChecked={true} checked={order?.hotLoad}
                             onClick={() => order.hotLoad = !order?.hotLoad}/>
            </IonItem>
            <IonItem>
                <IonLabel>Tarp Required</IonLabel>
                <IonCheckbox defaultChecked={true} checked={order.tarpRequired}
                             onClick={() => order.tarpRequired = !order.tarpRequired}/>
            </IonItem>
            <IonItem>
                <IonLabel>Two Stop</IonLabel>
                <IonCheckbox defaultChecked={false} checked={order.isTwoStop}
                             onClick={() => order.isTwoStop = !order.isTwoStop}/>
            </IonItem>

            <IonItem>
                <IonLabel>Send to Board</IonLabel>
                <IonCheckbox defaultChecked={true} checked={order.sendToBoard}
                             onClick={() => order.sendToBoard = !order.sendToBoard}/>
            </IonItem>
            <IonButton className="ion-margin-top" type="submit" expand="block" onClick={addUpdateLoad}
                       disabled={state.buttonDisabled}>
                Save
            </IonButton>
        </div>

    );
};

export default Auctionedit;
